import styled from 'styled-components';

const ListItem = styled.li`
  display: flex;
  height: 100%;

  > a {
    display: flex;
    flex: 1;
    align-items: center;

    cursor: pointer;

    text-decoration: none;
    color: inherit;
    font-family: 'DanskeTextv2-SemiBold';
  }

  > a,
  > svg {
    &:hover {
      color: ${({ theme }) => theme.Action};
    }
  }
`;

export default ListItem;
